// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { headerShipToAddressStyles } from "@bg/Overrides/Widgets/Common/HeaderShipToAddress";
import { fontConfig } from "@bg/XDL/PreStyle/typography";
import { css } from "styled-components";

headerShipToAddressStyles.shipToAddressWrapper = {
    css: css`
        display: flex;
        width: 100%;
        justify-content: flex-start;
        align-items: center;

        &&&& {
            * {
                font-size: ${fontConfig.fontSize.xxSmall}px;
                font-weight: ${fontConfig.weight.semiBold};
                letter-spacing: 1px;
                line-height: ${fontConfig.lineHeight.xSmall};
            }
        }

        .branch-name-lbl {
            display: none;
        }
    `,
};
